<script lang="ts">
import type {Evento} from "./Evento";



    export let evento: Evento;
    function share()
	{
        let titolo = evento.titolo;
        let id_evento = evento.pk;
		let url = `https://${window.location.hostname}/#evento_${id_evento}`;
		if (navigator.share)
		{
			navigator.share({
			title: titolo,
			url: url,
			text: titolo + "\n" + url
			});
			//M.toast({html: 'Condiviso navigator.share', classes: 'rounded'});
		}
		else
		{
			//M.toast({html: 'Impossibile condividere!', classes: 'rounded'});
		}
	}
</script>
{#if navigator && navigator.share }
	<button type="button" on:click={share}>
		<span class="icon-share"></span>	
	</button>
{/if}
